module.exports = __webpack_public_path__ + "static/media/Entrix.fed50167.png";